import { TypedEvent } from "../../typed_event"
import { JsEnv } from '../../../core/models/js_env';
import HistoryUtil from '../../util/history_util';
import DomUtil from "../../util/dom_util";
import { UserReviewRefineSearch } from "../../models/user_review_refine_search/user_review_refine_search"
import { UserReviewRefineSearchRepository } from "../../repositories/user_review_refine_search/user_review_refine_search_repository"
import { UserReviewRefineSearchContainer } from "../../views/pc/user_review_refine_search/user_review_refine_search_container"
import { UserReviewRefineSearchJsEnv, QueryParameter } from "../../models/user_review_refine_search/user_review_refine_search_js_env";
import { ReviewJsEnv } from '../../../review/listItem/models/review_js_env';
import { FeedbackContainer } from '../../views/pc/review/feedback_container';
import { DeleteLinkContainer } from '../../views/pc/review/delete_link_container';

export class UserReviewRefineSearchAction {
  static readonly UPDATE_EVENT = new TypedEvent<UserReviewRefineSearch>();
  private static state: UserReviewRefineSearch;
  private static userReviewRefineSearchRepository: UserReviewRefineSearchRepository;

  static async init(env: JsEnv) {
    this.userReviewRefineSearchRepository = new UserReviewRefineSearchRepository();
    this.state = new UserReviewRefineSearch(env.PAGE);
    new UserReviewRefineSearchContainer(); // NOSONAR
    // メソッドをwindowに外だしするとthisがwindowに指すため、ここでthisをクラスとバインドする必要がある
    env.FUNCTIONS['refreshUserReviewRefineSearchAreas'] = this.refreshUserReviewRefineSearchAreas.bind(this);
    // 戻るボタンと進むボタンをハンドル
    window.onpopstate = this.popStateHandler.bind(this);
  }

  // 絞り込みのプルダウンメニューからこのメソッドを呼び出す
  private static async refreshUserReviewRefineSearchAreas(newParameters: QueryParameter[], popStateEvent?: PopStateEvent) {
    this.state.showLoadingSpinner();

    const isHistory = popStateEvent
    if (isHistory) {
      // 戻るボタン、進むボタンの場合はevent内のモデルで現在のモデルを更新
      this.state.updateSearchParameterFromPopstateEvent(popStateEvent?.state?.refineSearchParameter);
    } else {
      // 最初のページにいた場合、stateにpopstateイベントで必要な情報を設定する
      if (history.state === null && HistoryUtil.isBrowserSupportsHistory()) {
        HistoryUtil.replaceNewUrlToHistory(window.location.href, { refineSearchParameter: this.state.getRefineSearchParameter() });
      }
      // 画面のプルダウンメニューを押下した場合はonchangeイベントの引数からモデルを更新
      this.state.updateSearchParameter(newParameters);
    }
    const urlForNewDoc = this.state.createSearchUrl();

    if (!HistoryUtil.isBrowserSupportsHistory()) {
      window.location.href = urlForNewDoc;
      return;
    }

    const htmlForRender = await this.userReviewRefineSearchRepository.getUserReviewRefineSearchHtml(urlForNewDoc);

    const newJsEnv = DomUtil.getJsEnv<UserReviewRefineSearchJsEnv>(htmlForRender);
    if (newJsEnv) {
      // ページングされると、/review/{商品番号}-ページ番号/のようにパスにページ番号が差し込まれる。
      // /review/{商品番号}/?page=ページ番号のURL形式にするため、selfLinkを更新する。
      this.state.updateSelfLink(newJsEnv.selfLink)
    }

    const urlForPushingHistory = this.state.createSearchUrl();
    if (!isHistory) {
      HistoryUtil.pushNewUrlToHistory(urlForPushingHistory, { refineSearchParameter: this.state.getRefineSearchParameter() });
    }

    this.state.updateHtmlForRender(htmlForRender);
    this.UPDATE_EVENT.trigger(UserReviewRefineSearchAction.state);

    const newReviewJsEnv = DomUtil.getJsEnv<ReviewJsEnv>(htmlForRender);
    if (newReviewJsEnv) {
      newReviewJsEnv.reviewJsOptions.forEach((opt) => {
        FeedbackContainer.init(opt.feedBackModel);
        DeleteLinkContainer.init(opt.deleteReviewModel);
      });
    }
  }

  private static popStateHandler(event: PopStateEvent) {
    this.refreshUserReviewRefineSearchAreas([], event);
  }
}
